import Axios from "axios"
import { CMSPath_Master } from "../config/constant"

const base_url = Axios.create({ baseURL: `${CMSPath_Master}/RewardsApiApp/rest` })

export const getTheKnowLoginUrl = async () => {
    try {
         
        const data = await Axios.get(`${CMSPath_Master}/RewardsApiApp/rest/theknow/sso`);
        console.log("getTheKnowLoginUrl", data.data)
        return data.data;
        

    } catch (err) {

        throw new Error(err);
    }
}

export const getVredAccessToken = async (url,payload) => {
    console.log("inside getVredAccessToken",url , payload)

    try {
        let x_encoded_payload = new URLSearchParams();
        for( let [key,value] of Object.entries(payload)){
            x_encoded_payload.append(key, value);
        }
        

        const data = await Axios.post(url,x_encoded_payload, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });

        console.log("getVredAccessToken", data.data)
        return data.data;
        

    } catch (err) {
        console.log("catch error", err)
        throw err;
    }
}

export const getVredStayData = async (memberId) => {
    try {

        let payload={
            "payload": {
                "dateFrom": "", //Optional (Format YYYYMMDD)
                "dateTo": "", //Optional (Format YYYYMMDD)
                "confNumber": "", //Optional
                "roomNumber": "", //Optional
                "lastUpdatedDate": "", //Optional (Format YYYYMMDD)
                "lastUpdatedToDate": "", //Optional (Format YYYYMMDD)
                "memberId": memberId //Required (received from login API)
            }
        }

        const data = await Axios.post(`${CMSPath_Master}/RewardsApiApp/rest/reservationStay`, payload,       
            { headers: { "Authorization": `Bearer ${localStorage.getItem("GuestJourneyMasterConnectorSessionToken")}` }});
    
        console.log("getVredStayData", data.data)
        return data;
        

    } catch (err) {
        throw err;
    }
}


export const getVredPointsData = async (accessToken) => {
    try {
 
        const data = await Axios.get(`${CMSPath_Master}/RewardsApiApp/rest/memberActivity?partnerUserId=boxy-duns-pass-wads`,{headers:{"Authorization":`Bearer ${accessToken}`}});
        console.log("getVredPointsData", data.data)
        return data;
        

    } catch (err) {
        console.log(err)
        throw err;
    }
}



export const getVredUrlsData = async () => {
    try {
 
        const data = await Axios.get(`${CMSPath_Master}/RewardsApiApp/rest/getAppUrlConfigs`);
        console.log("getVredUrlsData", data.data)
        return data;
        

    } catch (err) {
        throw err;
    }
}


export const updateLinkedAccountInfo = async (accessToken, memberId) => {
    console.log("inside updateLinkedAccountInfo")
    try {
        
        const data = await Axios.post(`${CMSPath_Master}/RewardsApiApp/rest/updateLinkedAccountInfo?membershipId=${memberId}`,{}, {headers:{"Authorization":`Bearer ${accessToken}`}});
        console.log("updateLinkedAccountInfo", data.data)
        return data;
        
    } catch (err) {
        console.log(err)
        throw err;
    }
}
